import request from "../utils/request";

export async function getExpenseDefinitionList(payload) {
  let query = serialize(payload);
  return request.get("ExpenseDefinition/List?" + query);
}

export async function getExpenseDefinitionNameList(){
  return request.get("ExpenseDefinition/NameListSelect");
}

export async function createNewExpenseDefinition(newExpenseDefinition){
  return request.post("ExpenseDefinition/Create",newExpenseDefinition);
}

export async function updateExpenseDefinition(expenseDefinition){
  return request.post("ExpenseDefinition/Update",expenseDefinition);
}

export async function deleteExpenseDefinition(id){
  return request.delete('ExpenseDefinition/Delete?id='+id);
}

function serialize(obj, prefix) {
  let str = [], p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}

